import {Component, OnDestroy, OnInit} from '@angular/core';
import {IDialogView} from '@shared/components/ok-cancel-dialog/ok-cancel-dialog.component';
import {DialogModel} from '@shared/models/dialog.model';
import {AuditTrackerService} from '@features/audit-tracker/services/audit-tracker.service';
import {take, takeUntil} from 'rxjs/operators';
import {Subject} from 'rxjs';
import {FormBuilder, Validators} from '@angular/forms';
import {PlatformQueryService} from '@core/services/platform-query.service';
import {PlatformQuery} from '@shared/models/platform-query/platform-query';

@Component({
    standalone: false,
    selector: 'app-start-workflow-dialog',
  templateUrl: './start-workflow-dialog.component.html',
  styleUrls: ['./start-workflow-dialog.component.scss']
})
export class StartWorkflowDialogComponent implements OnInit, IDialogView, OnDestroy {
  inputForm: any;
  data: DialogModel;
  flowTemplates: any[];
  private ngUnsubscribe = new Subject<void>();

  constructor(private formBuilder: FormBuilder,
              private platformQueryService: PlatformQueryService,
              private service: AuditTrackerService) {
    this.inputForm = this.formBuilder.group({
      flowTemplate: ['', Validators.required],
      // reference: ['', Validators.required]
    });
  }

  ngOnInit(): void {
    const query = new PlatformQuery();
    query.name = 'FlowTemplateQuery';
    query.api = 'FlowApi';

    this.platformQueryService.executeQuery(query).pipe(take(1)).subscribe(response => {
      this.flowTemplates = response.fieldValues['FlowTemplates'];
    });
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  onOkClicked(): boolean {
    const flowTemplateControl = this.inputForm.controls['flowTemplate'];
    // const referenceControl = this.inputForm.controls['reference'];
    flowTemplateControl.markAsTouched();
    // referenceControl.markAsTouched();

    if (flowTemplateControl.hasError('required')) {
      return false;
    }

    this.data.input['flowTemplateId'] = flowTemplateControl.value;
    // this.data.input['reference'] = referenceControl.value;

    return true;
  }
}
